import i18n from '@/utils/i18n';
import React from 'react';
import ShieldIcon from '@assets/icons/shield.svg';
import { createStyles } from '@/contexts/theme-context';
import { Text, View, ViewStyle } from 'react-native';
import { TYPOGRAPHY } from '@/styles';

interface Props {
  style?: ViewStyle;
}

export const PeakPriceShield: React.FC<Props> = ({ style }) => {
  const [styles, theme] = useStyles();
  return (
    <View style={[styles.content, style]}>
      <ShieldIcon stroke={theme.colors.inactiveText} style={styles.icon} />
      <Text numberOfLines={1} style={styles.text}>
        {i18n.t('price_protected')}
      </Text>
    </View>
  );
};

const useStyles = createStyles((theme) => ({
  content: {
    alignItems: 'center',
    backgroundColor: theme.colors.background,
    borderRadius: 8,
    flexDirection: 'row',
    paddingHorizontal: 8,
  },
  icon: {
    flexShrink: 0,
  },
  text: {
    ...TYPOGRAPHY.xsmall,
    color: theme.sk.color.text.secondary,
    paddingLeft: 4,
  },
}));
